import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberService } from '../services/member.service';
import { CookieService } from 'ngx-cookie';
import { Constants } from '../../assets/constants';

@Component({
  selector: 'app-product-selection',
  templateUrl: './product-selection.component.html',
  styleUrls: ['./product-selection.component.scss'],
})
export class ProductSelectionComponent implements OnInit {
  collapsed: boolean = true;
  constants = Constants;
  products: any = [];
  selectedProduct = {
    Participant: 'Select',
    FundId: null,
    PortfolioId: null,
    PortfolioName: null,
    FundCreditPercentage: null,
    NumberOfUnits: null,
    FundCredit: null,
  };

  constructor(
    private router: Router,
    private memberService: MemberService,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    console.log('ProductSelectionComponent: Loading...');
    this.activatedRoute.data.subscribe((data) => {
      if (data.routeResolver && data.routeResolver.Funds) {
        console.log('ProductSelectionComponent: Data loaded successfully');
        this.products = data.routeResolver.Funds;
      } else {
        console.error(
          'ProductSelectionComponent: No data available, redirecting to /unauthorized'
        );
        this.router.navigate(['/unauthorized'], { replaceUrl: true });
      }
    });
  }

  viewProductInfo() {
    this.router.navigate(['/view-eac']);
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

  updateProductSelection(product: any) {
    this.selectedProduct = product;
    this.memberService.cacheProductInfo(product);
    this.cookieService.put('selected_product', JSON.stringify(product));
  }
}
